import { render } from "./Brand.vue?vue&type=template&id=1ff8dcba&scoped=true"
import script from "./Brand.vue?vue&type=script&lang=js"
export * from "./Brand.vue?vue&type=script&lang=js"

import "@/assets/scss/_filter_TEMP.scss?vue&type=style&index=0&id=1ff8dcba&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff8dcba"]])

export default __exports__